import React, { useState } from "react";
import Accordion from "./Accordion";
import Parser from "html-react-parser";
import _ from "lodash";

class Itinerary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      block1: true,
      data: {},
      nums: [],
    };
  }

  toggle = (flag, index) => {
    _.map(this.state.nums, (num) => {
      if (num === index) {
        this.setState({ [`block${num}`]: !flag });
      } else if (num !== index) {
        this.setState({ [`block${num}`]: false });
      }
    });
  };

  toggleExpand = (expand = false) => () => {
    _.map(this.state.nums, (num) => {
      this.setState({ [`block${num}`]: expand });
    });
  };

  componentDidMount() {
    const data = this.props.data.view;
    const nums = _.range(this.props.data.length);

    this.setState({
      data: data,
      nums: nums,
    });

    _.map(nums, (num) => {
      const flag = num === 0 ? true : false;
      this.setState({ [`block${num}`]: flag });
    });
  }

  render() {
    const { data } = this.props;
    // let nums = _.range(data.view.length);
    // console.log(nums);

    // _.map(nums, num => {
    //   this.setState({ [`block${num}`]: false });
    // });
    // console.log(data.view);

    return (
      <div>
        {/* <div className="d-flex">{Parser(this.props.itinerary)}</div> */}
        <div className="d-flex">
          <div className="ml-auto">
            <button
              type="button"
              className="btn-custom text-uppercase"
              onClick={this.toggleExpand(true)}
            >
              Expand
            </button>
            <button
              type="button"
              className="btn-custom-clear text-uppercase"
              onClick={this.toggleExpand()}
            >
              Collapse
            </button>
          </div>
        </div>
        <dl className="accordion">
          {_.map(data, (item, index) => {
            return (
              <Accordion
                title={item.field_itinerary_location}
                onClick={(e) => this.toggle(this.state[`block${index}`], index)}
                expand={this.state[`block${index}`]}
                section={Parser(item.field_itin_summary)}
                id={`block${index}`}
                key={index}
              />
            );
          })}
        </dl>
      </div>
    );
  }
}

export default Itinerary;
